/* eslint-disable @typescript-eslint/no-unused-vars */
import { ChatClient, Conversation, Status } from '@hiberworld/chat-client';
import { OnlineFriendsQuery } from 'generated/graphql';
import { OnlineStatus } from 'hooks/useUserSession';
import React from 'react';

export type ChatWindow = 'conversations' | 'chat' | 'groupInfo' | 'startGroupChat' | 'inviteMore' | 'searchFriends';

export type ChatFriend = {
  username: string;
  pictureUrl: string;
  sessionStatus: OnlineStatus;
  session?: OnlineFriendsQuery['onlineFriends'][number]['user']['session'] | null;
  id: number;
  isValidAge: boolean;
  dmEnabled: boolean;
};

export type ChatConversation = {
  conversation: Conversation;
  disclaimerText?: string;
};

export type ChatContextType = {
  conversations: Conversation[];
  client: ChatClient | null;
  status: Status;
  activeConversation: ChatConversation | null;
  setActiveConversation: (conversation: ChatConversation | null) => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  openConversation: (user?: ChatFriend) => void;
  timedOut: boolean;
  currentWindow: ChatWindow;
  setCurrentWindow: (window: ChatWindow) => void;
};

export const ChatContext = React.createContext<ChatContextType>({
  client: null,
  conversations: [],
  status: Status.Offline,
  setActiveConversation: (conversation: ChatConversation) => {},
  activeConversation: null,
  isOpen: false,
  setIsOpen: () => {},
  openConversation: () => {},
  timedOut: false,
  currentWindow: 'conversations',
  setCurrentWindow: (window: ChatWindow) => {},
});
